var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2V0H20V2H12ZM12 6V4H20V6H12ZM12 10V8H20V10H12ZM6 9C5.16667 9 4.45833 8.70833 3.875 8.125C3.29167 7.54167 3 6.83333 3 6C3 5.16667 3.29167 4.45833 3.875 3.875C4.45833 3.29167 5.16667 3 6 3C6.83333 3 7.54167 3.29167 8.125 3.875C8.70833 4.45833 9 5.16667 9 6C9 6.83333 8.70833 7.54167 8.125 8.125C7.54167 8.70833 6.83333 9 6 9ZM0 15V13.1C0 12.75 0.0833333 12.4167 0.25 12.1C0.416667 11.7833 0.65 11.5333 0.95 11.35C1.7 10.9 2.496 10.5627 3.338 10.338C4.18 10.1133 5.06733 10.0007 6 10C6.93267 9.99933 7.82033 10.112 8.663 10.338C9.50567 10.564 10.3013 10.9013 11.05 11.35C11.35 11.5333 11.5833 11.7833 11.75 12.1C11.9167 12.4167 12 12.75 12 13.1V15H0Z",
    fill: "#F6764E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryIcon);
export default __webpack_public_path__ + "static/media/directoryIcon.5ffcc95553fa59c0d10320b165fe1f6c.svg";
export { ForwardRef as ReactComponent };